"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const react_2 = require("@osmosys/react");
exports.Nav = ({ basePath, workspace }) => {
    const path = basePath.replace(':id', `${workspace && workspace.id}`);
    return (react_1.default.createElement(reusables_1.NavPills, { center: true, queryDetailLayout: true, tabs: [
            {
                id: 'home',
                name: react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "workspace" }),
                to: `${path}/`,
            },
            {
                id: 'users',
                name: 'Users',
                to: `${path}/users`,
            },
            {
                adminRole: 'workspace',
                id: 'invite',
                name: 'Invite user',
                to: `${path}/invite-user`,
            },
            {
                adminRole: 'workspace',
                exact: false,
                id: 'dashboards',
                name: 'Dashboards',
                show: () => {
                    return (workspace &&
                        workspace.dashboardUrls &&
                        Array.isArray(workspace.dashboardUrls) &&
                        workspace.dashboardUrls.length > 0);
                },
                to: `${path}/dashboards`,
            },
            {
                adminRole: 'workspace',
                id: 'settings',
                name: 'Settings',
                to: `${path}/settings`,
            },
            {
                adminRole: 'app',
                id: 'admin',
                name: 'Admin',
                to: `${path}/admin`,
            },
        ] }));
};
//# sourceMappingURL=Nav.js.map